import type { LoginPolicy } from "../../../web-shared/loginPolicyTexts";

export function LoginPolicyBlock({
  policy,
  variant = "internal",
}: {
  policy: LoginPolicy;
  variant?: "internal" | "partner" | "redirect";
}) {
  return (
    <div className={`nx-login-policy nx-login-policy--${variant}`}>
      <p className="nx-login-policy__title">{policy.title}</p>
      <ul className="nx-login-policy__list">
        {policy.lines.map((line) => (
          <li key={line}>{line}</li>
        ))}
      </ul>
    </div>
  );
}
